<template>
<main>
    <div class="container-fluid my-5">
        <h1>Alunni/e e classi</h1>

        <div class="row">
            <div class="col-12 col-lg-10 mt-4 my-lg-0 px-0 mx-auto">
                <div class="row g-0 justify-content-evenly justify-content-sm-center align-items-center">
                    <div class="col-auto">
                        <a href="/structure/PatientListAction" class="erk btn btn-outline-secondary " aria-label="Elenco alunni/e">ALUNNI/E</a>
                    </div>
                    <div class="col-auto">
                        <a href="/structure/GroupListAction" class="erk btn btn-outline-secondary active" aria-label="Elenco classi">CLASSI</a>
                    </div>
                </div>
            </div>
        </div>

        <div class="search-container mt-4 mb-0 my-lg-5">
            <div class="row">
                <div class="col-12 col-lg-10 mx-auto">
                    <div class="row">

                        <!-- Pulsante azione sinistra -->
                        <div class="col-auto col-sm mx-0 px-0">
                            <a class="erk btn btn-secondary" href="/structure/GroupListAction-edit">
                                <span class="bi bi-plus-circle"></span>
                                <span class="d-none d-lg-inline-block">Aggiungi classe</span>
                            </a>
                        </div>
                        <!-- /Pulsante azione sinistra -->

                        <!-- Ricerca centrale / filtri -->
                        <div class="col col-sm-9 mx-0 px-0 col-lg-6">
                            <div class="input-group">
                                <input v-model="form.search" 
                                    @keyup.enter="doSearch()"
                                    type="text" class="form-control" placeholder="" aria-label="" aria-describedby="button-addon1" name="filter_name">
                                <button @click="doSearch()" class="btn btn-primary">
                                    <i class="bi bi-search pr-1"></i> <span class="d-none d-lg-inline-block">Cerca</span>
                                </button>
                            </div>
                        </div>
                        <!-- /Ricerca centrale / filtri -->
                        
                        <!-- Menu opzioni -->
                        <div class="col text-end d-none d-lg-inline-block">
                            <div class="dropdown erk-menu-options">
                                <button class="erk btn btn-light dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                    <span class="d-none d-lg-inline-block">Opzioni alunni/e</span> <i class="bi bi-grid-3x3-gap-fill"></i>
                                </button>
                                <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton1">
                                    <li>
                                        <a target="_blank" href="/structure/GroupListAction-export" title="Espota dati" class="dropdown-item">
                                            Esporta dati
                                            <i class="bi bi-file-earmark-excel"></i>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <!-- /Menu opzioni -->
                    </div>
                </div>
            </div>
        </div>
        
        <MbLoading v-if="isLoading" text="Caricamento utenti..."></MbLoading>
        <div v-else-if="users.length == 0" class="row">
            <div class="col-12 col-sm-10 col-md-8 col-lg-10 mx-auto text-center">
                <p>
                    Nessuno utente trovato.
                </p>
            </div>
        </div>
        <div v-else class="row mt-lg-5">
            <div class="col-lg-10 mx-auto my-4 my-lg-1">
                <div class="dropdown d-flex justify-content-end ordinaper pb-2">
                    <a class="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                        Ordina per: 
                        <span id="ordinaperselected" class="fw-bolder">
                            <template v-if="form.orderBy == 'name'">
                                Nome
                            </template>
                            <template v-else>
                                Data inserimento
                            </template>
                        </span>
                    </a>
                    <ul class="dropdown-menu mb-3 p-0 m-0" style="min-width: 220px;">
                        <li>
                            <a 
                                @click="form.orderBy = 'name'"
                                class="dropdown-item py-2"
                                :class="{'active': form.orderBy === 'name'}"
                                style="cursor: pointer;"
                                >
                                Nome
                            </a>
                        </li>
                        <li>
                            <a 
                                @click="form.orderBy = 'insertDate'"
                                class="dropdown-item py-2"
                                :class="{'active': form.orderBy === 'insertDate'}"
                                style="cursor: pointer;"
                                >
                                Data inserimento
                            </a>
                        </li>
                    </ul>
                </div>

                <div class="row">
                    <div v-for="user in users" :key="user.id" class="col-12 col-md-6 col-lg-4 mb-4">
                        <a :href="'/structure/group/StudentListAction?groupId=' + user.group_id" class="nome-card">
                            <div class="card-body p-4 text-center border-bottom">
                                <img :src="'/assets/img/avatars/class/' + user.avatar + '.svg'" alt="" class="rounded-circle mb-0" width="130" height="130" />
                            </div>
                            <ul class="px-2 py-2 bg-light list-unstyled d-flex align-items-center justify-content-center mb-0">
                                <li class="position-relative">
                                    <h5 class="fw-semibold mb-0">{{ user.name }} - alunni/e: {{ user.student_count ? user.student_count : 0}}</h5>
                                </li>
                            </ul>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</main>
</template>
<script>

import MbLoading from '@/components/ui/base/MbLoading.vue';
import axios from 'axios';

export default{
    components:{
        MbLoading
    },
    data(){
        return{
            isLoading: true,
            users: [],
            form:{
                search: '',
                orderBy: 'name'
            }
        }
    },
    watch:{
        'form.orderBy': function(){
            this.doSearch();
        }
    },
    mounted(){
        this.doSearch();
    },
    methods:{
        doSearch(){
            this.isLoading = true;
            axios.post("/structure/GroupListAction-users?outFormat=json", this.form)
                .then(response => {
                    this.users = response.data;
                    this.isLoading = false;
                })
        }
    }
}

</script>